/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLanguage = createReactComponent("outline", "language", "IconLanguage", [["path", { "d": "M4 5h7", "key": "svg-0" }], ["path", { "d": "M9 3v2c0 4.418 -2.239 8 -5 8", "key": "svg-1" }], ["path", { "d": "M5 9c0 2.144 2.952 3.908 6.7 4", "key": "svg-2" }], ["path", { "d": "M12 20l4 -9l4 9", "key": "svg-3" }], ["path", { "d": "M19.1 18h-6.2", "key": "svg-4" }]]);

export { IconLanguage as default };
//# sourceMappingURL=IconLanguage.mjs.map
